// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Ke73","logo":"Home_logo__s21Dj","subContent":"Home_subContent__6pjrd","title":"Home_title__1aNQh","ai":"Home_ai__n71Nc"};